import { useEffect, useState } from "react";
import { useGlobalContext } from "../GlobalContext";

const ProsesManasuka = () => {
  const tglSekarang = new Date().toISOString().split("T")[0];
  const { periode, api } = useGlobalContext();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [statusDiproses, setStatusDiproses] = useState(false);

  const [formData, setFormData] = useState({
    tglTransak: tglSekarang   
  });

  useEffect(() => {
    const cekStatus = async () => {
      try {
        const response = await api.get(`/api/proses/statusjasamanasuka/${periode}`);
        setStatusDiproses(response.data.pmanasuka === true || response.data.pmanasuka === '1');
      } catch (error) {
        console.error("Error Cek Status Jasa Manasuka:", error);
      }
    };
    if (periode) {
      cekStatus();
    }
  }, [periode, api]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const getAnggota = async () => {
    try {
      const response = await api.get(`/api/anggota/anggotamanasuka`);
      return response.data.data || []
    } catch (error) {
      console.error("Error Ambil Data Anggota Manasuka:", error);
      return [];
    }
  };

  const getSaldoManasuka = async () => {
    try {
      const response = await api.get(`/api/master/saldomanasuka/${periode}`);
      return response.data || []
    } catch (error) {
      console.error("Error Ambil Data Saldo Simp. Manasuka:", error);
      return [];
    }
  };

  const getSetoranManasuka = async (tahun, bulan) => {
    const tglawal = `${tahun}-${bulan}-01`;
    const tglakhir = `${tahun}-${bulan}-15`;
    try {
      const response = await api.get(`/api/transaksi/totalsetoranmanasuka/${tglawal}/${tglakhir}`);
      return response.data || []
    } catch (error) {
      console.error("Error Ambil Data Setoran Manasuka:", error);
      return [];
    }
  };

  const getTarikManasuka = async (tahun, bulan) => {
    try {
      const response = await api.get(`/api/transaksi/totaltarikmanasuka/${tahun}/${bulan}`);
      return response.data || []
    } catch (error) {
      console.error("Error Ambil Data Tarik Manasuka:", error);
      return [];
    }
  };

  const GetNoTransaksiManasuka = async (noawal) => {
    let notransaksi = '';
    try {
      const response = await api.get(`/api/transaksi/getnotransaksimanasuka/${noawal}`);
      if (response.status === 200 && response.data.notransaksi) {
        const noindextransnext = parseInt(response.data.notransaksi.toString().substring(5, 10)) + 1;
        notransaksi = noawal + noindextransnext.toString().padStart(6, '0');
      }        
    } catch (error) {
      notransaksi = noawal + '000001';
    }      
    return notransaksi;
  };

  const handleProses = async () => {   
    const [tahun, bulanStr, tglStr] = formData.tglTransak.split('-');
    const bulan = parseInt(bulanStr).toString();   
    const days = parseInt(tglStr); //countDays(formData.tglTransak);  
    const noawal = periode.toString();
    const notransaksiwal = (noawal.substring(2, 6));
    const notransaksi = await GetNoTransaksiManasuka(notransaksiwal);
    const date = new Date(formData.tglTransak);
    const yyyymm = `${date.getFullYear()}${String(date.getMonth() + 1).padStart(2, "0")}`;
    let indexnotransaksi = parseInt(notransaksi.substring(5, 10));
    
    if (statusDiproses) {
      alert(`Proses Jasa Manasuka periode ${periode} sudah dilakukan, tidak bisa diproses kembali`);
      return;
    }

    if (yyyymm !== periode) {
      alert(`Tanggal Proses Jasa tidak sesuai dengan periode`);            
      return;
    }

    setLoading(true);
    setMessage("");        

    try {
      const [datamanasuka, datasldmanasuka, datasetor, datatarik] = await Promise.all(
        [
          getAnggota(),
          getSaldoManasuka(),
          getSetoranManasuka(tahun, bulan),
          getTarikManasuka(tahun, bulan)
        ]
      );

      //console.log("Data Saldo Manasuka:", datasldmanasuka);

      if (!Array.isArray(datamanasuka) || !Array.isArray(datasldmanasuka) || !Array.isArray(datasetor) || !Array.isArray(datatarik)) {
        console.error("Data diterima bukan array:");
        alert("Data tidak valid.");
        setLoading(false);
        return;
      }
      
      const recordJasaManasuka = 
      datamanasuka.map((item) => {
        const saldosimp = datasldmanasuka.find(s => String(s.noanggota??"").trim() === String(item.noanggota??"").trim()) || { saldoawal : 0, saldoakh : 0 };
        const setor = datasetor.find(s => String(s.noanggota??"").trim() === String(item.noanggota??"").trim()) || { totaltabung: 0 };
        const tarik = datatarik.find(s => String(s.noanggota??"").trim() === String(item.noanggota??"").trim()) || { totaltarik: 0 };

        let mjasa36 = 0;
        if (item.jenis_mnsuka === "1" || item.jenis_mnsuka === "2" ) {
          mjasa36 = (0.05 / 100) / days;
        }       
              
        const msaldo =
              Number(saldosimp.saldoawal ?? 0) +
              Number(setor.totaltabung ?? 0) -
              Number(tarik.totaltarik ?? 0);
        const jmlhari = days;
        const mjasa = Math.round(jmlhari * (mjasa36 * msaldo));

        const nomorTransaksiBaru = notransaksiwal + indexnotransaksi.toString().padStart(6, '0');       
        if (saldosimp.saldoakh > 0) {
          indexnotransaksi += 1;
          return {
            notransaksi: nomorTransaksiBaru,
            tgltransak: formData.tglTransak,
            noanggota: item.noanggota,
            jenissimp: 1, 
            kdtrans: 3,            
            saldoawl: msaldo,
            debet: 0,    
            kredit: mjasa,            
            saldo: msaldo + mjasa
          };       
        } else {
          return null;
        }
      }).filter(item => item !== null);

      // TUNGGU SEMUA POST SELESAI SEBELUM LANJUT
      const results = await Promise.all(
        recordJasaManasuka.map(record =>
          api.post('/api/transaksi/simpananmanasuka', record)
            .then(res => {
              console.log("KIRIM BERHASIL:", record.notransaksi);
              return res;
            })
            .catch(error => {
              console.error("GAGAL KIRIM:", record.notransaksi, error.response?.data || error.message);
              throw error;
            })
        )
      );

      console.log("Semua data berhasil dikirim:", results.length, "records");

      try {
        await api.patch(`/api/proses/jasamanasuka/${periode}`);
      } catch (error) {
        console.error("Gagal update status Jasa Manasuka:", error.response?.data || error.message);
      }

      setMessage("Proses selesai & sukses. Redirect ke login...");      
      
      setTimeout(() => {        
        localStorage.removeItem('periode'); // Hapus data sesi pengguna
        window.location.href = '/login'; // Redirect ke halaman login
      }, 2000);
    } catch (err) {
      console.error("Error proses:", err); 
      setMessage("Gagal memproses. Lihat console untuk detail.");
      setLoading(false);
    }
  };

  return (
    <div className="container mt-5" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
      <div className="card card-info" style={{ width: "325px" }}>
        <div className="card-header">
          <h3 className="card-title">Proses Jasa Manasuka</h3>
        </div>
        <div className="card-body">
          {/* Bagian Atas */}
          <div className="form-group row">
            <label className="col-sm-4 col-form-label text-right">Tanggal</label>
            <div className="col-sm-3">
              <input
                type="date"
                className="form-control"
                name="tglTransak"
                value={formData.tglTransak}
                onChange={handleInputChange}
                style={{ width: '150px', height: '40px' }}
              />
            </div>
          </div>         
        </div>
        <div className="card-footer text-right">
          <button className="btn btn-success btn-sm" onClick={handleProses} disabled={loading || statusDiproses}>
            {loading ? "Memproses..." : "Proses"}
          </button>
          {loading && (
            <div className="text-center mt-2">
              <span className="text-info font-bold">Memproses data, harap tunggu...</span>
            </div>
          )}

          {message && (
            <div className="text-center mt-2">
              <span className="text-success font-bold">{message}</span>
            </div>
          )} 
        </div>
      </div>
    </div>
  ); 
};

export default ProsesManasuka;
